import { defaultApi } from "@/services/axiosInstances";
import store from "..";

const MAX_CACHE_AGE = 5 * 60 * 1000;

export default {
	namespaced: true,
	state: {
		list: [],
		listStatus: null,
		dataMap: {},
		statusMap: {},
		timestamps: {},
	},
	getters: {
		getList: (state) => state.list,
		isListLoading: (state) => state.listStatus === "loading",
		isListSuccess: (state) => state.listStatus === "success",

		getDataById: (state) => (id) => state.dataMap[id],
		getStatusById: (state) => (id) => state.statusMap[id]
	},
	mutations: {
		setListLoading(state) {
			state.listStatus = "loading";
		},
		setListSuccess(state, data) {
			state.list = data;
			state.listStatus = "success";
			data.forEach((d) => {
				state.dataMap[d.rombel_id] = d;
				state.statusMap[d.rombel_id] = "success";
				state.timestamps[d.rombel_id] = Date.now();
			});
		},
		setListError(state) {
			state.listStatus = "error";
		},

		setLoading(state, id) {
			state.statusMap[id] = "loading";
		},
		setSuccess(state, { id, data }) {
			state.dataMap[id] = data;
			state.statusMap[id] = "success";
			state.timestamps[id] = Date.now();
		},
		setNotFound(state, id) {
			state.statusMap[id] = "not_found";
			state.timestamps[id] = Date.now();
		},
		setError(state, id) {
			state.statusMap[id] = "error";
		},
		clearData(state, id) {
			delete state.dataMap[id];
			delete state.statusMap[id];
			delete state.timestamps[id];
		},
	},
	actions: {
		async fetchList({ commit, state }) {
			if (state.listStatus === "success") return;
			commit("setListLoading");
			try {
				const semester = store.getters.getSemester;
				const { data } = await defaultApi.post("/list/rombel", {
					semester_id: semester.semester_id,
				});
				commit("setListSuccess", data.rombel || []);
			} catch (err) {
				console.error(err.response?.data?.message);
				commit("setListError");
			}
		},

		async fetchData({ state, commit }, rombelId) {
			const status = state.statusMap[rombelId];
			const timestamp = state.timestamps[rombelId];

			const now = Date.now();
			const isExpired = timestamp ? now - timestamp > MAX_CACHE_AGE : true;

			if (!isExpired && status === "success") {
				return;
			}

			commit("setLoading", rombelId);
			try {
				const { data } = await defaultApi.post("/title/rombel", {
					rombel_id: rombelId,
				});

				if (data) {
					commit("setSuccess", { id: rombelId, data: data.rombel });
				} else {
					commit("setNotFound", rombelId);
				}
			} catch (error) {
				console.error(error.response?.data?.message);
				commit("setError", rombelId);
			}
		},
	},
};
